export const statusLabels: Record<string, string> = {
  BN: 'Новая',
  IP: 'В работе',
  UR: 'Перерасчёт',
  ID: 'Спор',
  SF: 'Завершена',
  AA: 'Автоподтверждена',
  AAD: 'Одобрена в споре',
  FR: 'Завершена с перерасчётом',
  NF: 'Реквизит не найден',
  TO: 'Просрочена',
  CR: 'Отменена с перерасчётом',
  CANCELED: 'Отменена',
  STS: 'Поддержка',
  STSD: 'Спор в поддержке',
  PC: 'Проблема подтверждена',
};

export const statusTone = (status: string) => {
  if (['SF', 'AA', 'AAD', 'FR'].includes(status)) return 'success';
  if (['TO', 'NF', 'CR', 'CANCELED', 'PC', 'STS', 'STSD'].includes(status)) return 'danger';
  if (status === 'ID') return 'warning';
  return 'neutral';
};

export const formatMoney = (amount: string | number | null | undefined, currency: string) => {
  if (amount === null || amount === undefined || amount === '') return '—';
  return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 6 }).format(Number(amount))} ${currency}`;
};

export const shortId = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') return '—';
  const text = String(value);
  return text.length > 12 ? `${text.slice(0, 8)}…${text.slice(-4)}` : text;
};
